module.exports = __webpack_public_path__ + "img/game--it-takes-two.c3b6cef3.png";